import { render, staticRenderFns } from "./UpdateTransportation.vue?vue&type=template&id=218bca00&scoped=true"
import script from "./UpdateTransportation.vue?vue&type=script&lang=js"
export * from "./UpdateTransportation.vue?vue&type=script&lang=js"
import style0 from "./UpdateTransportation.vue?vue&type=style&index=0&id=218bca00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "218bca00",
  null
  
)

export default component.exports